// extracted by mini-css-extract-plugin
export default {"personal-info-edit-button":"personal-info-edit-button__xCTqN","personal-info-share-button":"personal-info-share-button__5zNqd"};